import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { putKjoretoyType } from "../../../../actions/kjoretoyTyperActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../../utils/validationUtils";
import ModalGeneric from "../../../Common/ModalGeneric";
import UpdateOpenModal from "../../CreateModals/UpdateOpenModal";
import KjoretoyTyperForm from "../../KjoretoyTyperForm";

const rules = {
  kode: "required;minLength=1;maxLength=50",
  navn: "required;minLength=1;maxLength=50",
};

function KjoretoyTyperModal({ kjoretoyType }) {
  const dispatch = useDispatch();
  const initState = () => ({
    open: false,
    submitButtonText: "Lagre",
    id: kjoretoyType.id,
    kode: kjoretoyType.kode,
    navn: kjoretoyType.navn,
    validationError: {},
  });
  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  useEffect(() => {
    setState((s) => ({
      ...s,
      kode: kjoretoyType.kode,
      navn: kjoretoyType.navn,
    }));
  }, [kjoretoyType]);

  const closeModal = () => setState(initState());

  const isFormValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePut = () => {
    update({ submitButtonText: "Lagrer..." });
    dispatch(
      putKjoretoyType({ id: state.id, kode: state.kode, navn: state.navn }),
    )
      .then(closeModal)
      .catch(() => update({ submitButtonText: "Lagre" }));
  };

  const saveAndClose = () => {
    if (isFormValid()) handlePut();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const draft = { ...state, [name]: value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <ModalGeneric
      modalTitle="Rediger kjøretøytype"
      open={state.open}
      closeModal={closeModal}
      openModal={() => update({ open: true })}
      OpenModalComponent={UpdateOpenModal}
      submit={saveAndClose}
      submitButtonText={state.submitButtonText}
    >
      <KjoretoyTyperForm
        kode={state.kode}
        navn={state.navn}
        handleChange={handleChange}
        validationError={state.validationError}
        actionType="update"
      />
    </ModalGeneric>
  );
}

export default KjoretoyTyperModal;
